/**
 * The proactive welcome is CLIENT-generated: when the BE reports no thread but the operator wrote
 * intro content, the shell synthesises a default thread with `chatId: ""` (not created on the BE
 * yet). It is not a message from the operator or a flow, so per the BE contract it is not "unread":
 * it must not light the launcher badge. Only a real unread
 * operator / flow message does.
 */
export const isClientWelcomeThread = (t: { chatId: string }): boolean => t.chatId === "";

/** Total unread across the REAL threads (the client welcome excluded). */
export function countRealUnread(threads: ReadonlyArray<{ chatId: string; unreadCount: number }>) {
  return threads.reduce(
    (sum, t) => (isClientWelcomeThread(t) ? sum : sum + (t.unreadCount || 0)),
    0,
  );
}
